import { gql } from '@apollo/client';

// Read-only Metabase API call, made by the server as the current organisation's Metabase user.
export const METABASE_REQUEST = gql`
  query MetabaseRequest($input: MetabaseRequestInput!) {
    result: metabaseRequest(input: $input) {
      data
    }
  }
`;
